module.exports = __webpack_public_path__ + "static/img/2a.d5839587.webp";